export type AnalyticsCase = {
  state?: string;
  status?: string;
  reasonCode?: string | null;
  createdAt?: string | null;
  resolvedAt?: string | null;
  closedAt?: string | null;
};

export function readableLabel(value: string) {
  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());
}

function dayKey(value: Date) {
  return `${value.getFullYear()}-${value.getMonth()}-${value.getDate()}`;
}

export function caseAnalytics(rows: AnalyticsCase[], days: number, now = new Date()) {
  const trend = Array.from({ length: days }, (_, index) => {
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() - days + index + 1);
    return {
      key: dayKey(date),
      label: date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }),
      created: 0,
      resolved: 0,
    };
  });
  const status = new Map<string, number>();
  const category = new Map<string, number>();
  let dated = 0;
  for (const row of rows) {
    if (!row || typeof row !== 'object') continue;
    const state = readableLabel(row.state || row.status || 'Unknown');
    status.set(state, (status.get(state) ?? 0) + 1);
    const reason = row.reasonCode ? readableLabel(row.reasonCode) : 'Uncategorised';
    category.set(reason, (category.get(reason) ?? 0) + 1);
    if (row.createdAt && Number.isFinite(Date.parse(row.createdAt))) dated++;
    for (const [field, value] of [
      ['created', row.createdAt],
      ['resolved', row.resolvedAt],
    ] as const) {
      if (!value || !Number.isFinite(Date.parse(value))) continue;
      const bucket = trend.find((item) => item.key === dayKey(new Date(value)));
      if (bucket) bucket[field]++;
    }
  }
  return {
    trend,
    dated,
    status: [...status].map(([label, count]) => ({ label, count })),
    category: [...category]
      .map(([label, count]) => ({ label, count }))
      .sort((a, b) => b.count - a.count),
  };
}
